import * as Yup from "yup";

export const SearchTicketsFormSchema = Yup.object().shape({
  ticketNumber: Yup.string().matches(/^[0-9]+$/, "Ticket must be a number"),
});
